import Locations from "model/locations";
import takeStep from "./takeStep";
import Admin from "admin";

const attempt = () => {
  const outcome = {
    success: true,
    gain: { location: Locations.Road.index },
    cost: {},
  };

  return outcome;
};

const executeSideEffects = (context, outcome) => {
  const { party } = context;
  const { history } = party;

  history.add(
    {
      action: !party.started() ? "DEPART" : "CONTINUE_TRIP",
      result: outcome,
    },
    context,
  );

  if (!party.started) {
    // TODO: fix this bug
    party.nextPhase();
  }
  party.stopResting();

  return takeStep.execute(context);
};

const depart = {
  title: ({ party }) => (party.started() ? "Continue" : "Depart"),
  hotkey: "c",
  enabled: (context) => !context.arrived,
  execute: (context) => {
    const outcome = attempt(context);
    const effects = executeSideEffects(context, outcome);

    const result = { ...outcome.gain, ...effects.context };
    return { result, notification: effects.notification };
  },
  cooldown: Admin().continueCooldown,
};

export default depart;
